'use strict';

module.exports = {
    SIGN: 'Kaydol',
    SIGN_JOIN: 'Ücretsiz olarak Kaydol ya da Katıl!',
    EMAIL_EXISTS: 'Bu e-posta halihazırda mevcut.',
    INVALID_EMAIL: 'Lütfen geçerli bir E-Posta Adresi girin',
    INVALID_FIRST_NAME: 'Lütfen geçerli bir Ad girin',
    INVALID_LAST_NAME: 'Lütfen geçerli bir Soyad girin',
    INVALID_PASSWORD: 'Lütfen 6-20 karakter arası giriş yapın (sadece A-Z, a-z, 0-9)',
    INVALID_REPASSWORD: 'Şifreler aynı değil',
    INVALID_VALID_CODE: 'Lütfen geçerli Kodu girin',
    UNAVIALABLE_SERVICE: 'Hizmete erişilemiyor, lütfen daha sonra tekrar deneyin.',
    EMPTY_VALID_CODE: 'Karakterleri resimde gördüğünüz biçimde yazın',
    NOT_MEMBER: 'Üye Değil misiniz?',
    ALREADY_MEMBER: 'Halihazırda AliExpress/Alibaba üyesi misiniz?',
    EMAIL: 'E-posta adresi',
    CONTACT_NAME: 'İletişim Adı:',
    FIRST_NAME: 'Ad',
    LAST_NAME: 'Soyad',
    PASSWORD: 'Şifre',
    REPASSWORD: 'Şifreyi Tekrar Girin:',
    EMPTY_CODE: 'Gösterilen Kodu Girin:',
    REFRESH: 'Yenile',
    CREATE_MY_ACCOUNT: 'Hesabımı Oluştur',
    NAME: 'isim',
    VERIFICATION: 'doğrulama kodu',
    AGREE_MENT: 'Hesap oluşturduğunuzda',
    AE_MEMBER_SHIP: 'AliExpress.com Ücretsiz Üyelik',
    AND: 've',
    PRIVACY_POLICY: 'Gizlilik Politikası’nı kabul etmiş sayılırsınız',
    SLIDE_SUBMIT: 'Doğrulamak için sağa kaydırın',
    SLIDE_SUBMIT_TIPS: 'Başarılı',
    LOADING: 'Yükleniyor…',
    SLIDE_SUBMIT_ERROR_TIPS: 'Doğrulamak için sağa kaydırın',
    SHOP_NOW: 'ŞIMDI ALIŞVERIŞ',
    SIGN_IN: 'Giriş yap',
    REGISTER_SMS: 'SMS ile kaydol',
    REGISTER_EMAIL: 'E-posta ile kaydol',
    PHONE_NUMBER: 'Telefon numarası',
    VALID_NUMBER: 'Lütfen geçerli bir telefon numarası girin.',
    SEND_SMS_CODE: 'SMS kodu gönder',
    SMS_POLICY: 'Verdiğiniz telefon numarasına SMS ile bir doğrulama kodu göndereceğiz. Hem ülke kodunu hem de telefon numarasını doğru yazdığınızdan emin olun.',
    SEND_TO: 'Kodu şuraya gönderdik:',
    VERIFICATION_RECEIVED: 'Aldığınız doğrulama kodunu girin veya',
    EDIT_NUMBER: 'numarayı değiştirin.',
    RESEND_CODE: 'Kodu yeniden gönder',
    LAST_STEP: 'Son Adım',
    SET_SIGN_IN_PASSWORD: 'Hesabınızın güvenliğini artırmak için lütfen şifre belirleyin.',
    INVALID_PHONE_PASSWORD: '6-20 karakter (yalnızca harf ve sayı)',
    NOT_CORRECT_CODE: 'Kod yanlış, lütfen tekrar deneyin.',
    SAVE_PASSWORD: 'Şifreyi kaydet',
    NO_RECEIVED_CODE: 'Kodu hala almadıysanız',
    VIA_EMAIL: 'e-posta ile kaydolun',
    GUID: "AliExpress'te satış yapmak",
    GUID_HREF: 'buraya tıklayın'
};